import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { Auth } from "aws-amplify"
import React, { Component } from "react"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import FetchSpinner from "../../global/FetchSpinner/FetchSpinner"
import SignUpHeader from "../../global/SignUpHeader/SignUpHeader"
import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import SupplierSignupPaymentCheckout from "../SupplierSignupPaymentCheckout/SupplierSignupPaymentCheckout"
import * as styles from "./SupplierSignupPayment.module.scss"
import bronzePlan from "./bronze-plan.png"
import fetchLambda from "@data/fetchLambda"
import lambdas from "@data/lambdas"

const { STRIPE_REQUEST } = lambdas[process.env.NEXT_PUBLIC_ENV]
const STRIPE_PUB_KEY = process.env.NEXT_PUBLIC_STRIPE_PUB_KEY
const NEXT_PUBLIC_STRIPE_MONTHLY_PRICE_ID = process.env.NEXT_PUBLIC_STRIPE_MONTHLY_PRICE_ID
const NEXT_PUBLIC_STRIPE_ANNUALLY_PRICE_ID = process.env.NEXT_PUBLIC_STRIPE_ANNUALLY_PRICE_ID

export default class SupplierSignupPayment extends Component {
  state = {
    stripe: null,
    selectedPrice: {},
    plans: null,
    currency: "GBP",
    isPlansLoaded: false,
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isPlansLoaded !== this.state.isPlansLoaded) {
      this.defaultPlan?.dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        })
      )
    }
  }

  componentDidMount = async () => {
    const stripePromise = loadStripe(STRIPE_PUB_KEY)
    this.setState({ stripe: stripePromise })

    const user = await Auth.currentSession()
    const session = user.getIdToken().getJwtToken()

    const stripeResult = await fetchLambda(STRIPE_REQUEST, {
      session: session,
      input: {
        action: "listPrices",
      },
    })

    // sort by price asc
    if (stripeResult.data.prices) {
      this.setState({
        listPrices: [...stripeResult.data.prices].sort((a, b) =>
          a.unit_amount != b.unit_amount ? a.unit_amount - b.unit_amount : -1
        ),
      })
    }
  }

  updateCurrency = (currency) => {
    this.setState({
      currency: currency,
    })
    document.querySelector("#checkout-section").classList.remove(styles.visible)
  }

  handleChange = (event) => {
    this.setState({
      selectedPrice: {
        id: event.target.id,
        name: event.target.dataset.name,
        desc: event.target.dataset.desc,
      },
    })

    document.querySelector("#checkout-section").classList.add(styles.visible)
    // document
    //   .querySelector("#checkout-section")
    //   .scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
  }

  render() {
    // const currencySymbol = this.state.currency === "GBP" ? "£" : "€"

    const plans = [
      {
        id: NEXT_PUBLIC_STRIPE_MONTHLY_PRICE_ID,
        nickname: "Monthly",
        priceExDesc: "£79.99 + vat per Month",
        priceIncDesc: "£79.99 + vat",
        tag: "30 Day Free Trial",
      },
      {
        id: NEXT_PUBLIC_STRIPE_ANNUALLY_PRICE_ID,
        nickname: "Annually",
        priceExDesc: "£125 + vat per year",
        priceIncDesc: "£125 + vat",
        tag: "plus 10% commission on confirmed work",
      },
      {
        id: "COMMISSION_ONLY",
        nickname: "Commission Only",
        priceExDesc: "No Fee",
        priceIncDesc: "No Fee",
        tag: "12.5% commission due on confirmed work",
      },
    ]

    return (
      <div className={styles.SupplierSignupPayment}>
        <SignUpHeader
          title="Welcome"
          content="You have now been approved to sign up for the world’s most exclusive community of wedding &amp; event suppliers."
        />

        <div className={styles.Payment}>
          <div className={styles.Subscriptions}>
            <form>
              <section className={styles.plans_overview}>
                <SiteWrapper narrow className={styles.wrapper}>
                  <div className={styles.intro}>
                    <h1>Choose a plan</h1>
                    <p>
                      To get started, please choose a plan that best suits your needs and then on the next pages you can
                      tell us a bit about yourselves. For any enquiries, please email:
                    </p>
                    <a href="mailto:supplier@houseofpartyplanning.com">supplier@houseofpartyplanning.com</a>
                    {/* <SupplierCurrencySelector updateCurrency={this.updateCurrency} currency={this.state.currency} /> */}
                  </div>
                  <div className={styles.plans}>
                    {plans.map((plan) => (
                      <div className={styles.plan}>
                        <input
                          id={plan.id}
                          name="id"
                          selected
                          onChange={this.handleChange}
                          type="radio"
                          data-name={plan.nickname}
                          data-desc={plan.priceIncDesc}
                        />
                        <label htmlFor={plan.id}>
                          <div className={styles.plan_header}>
                            <img src={bronzePlan} alt={plan.nickname} />
                            <span>{plan.nickname}</span>
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>{plan.priceExDesc}</ReactMarkdown>
                            <div className={styles.subtext}>
                              <h3>{plan.tag}</h3>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </SiteWrapper>
              </section>
            </form>
            <section className={styles.checkout} id="checkout-section">
              <SiteWrapper className={styles.wrapper}>
                <h1>Checkout</h1>
                <Elements stripe={this.state.stripe}>
                  <SupplierSignupPaymentCheckout
                    currency={this.state.currency}
                    authCheck={this.props.authCheck}
                    price={this.state.selectedPrice}
                  />
                </Elements>
              </SiteWrapper>
            </section>
          </div>
        </div>
      </div>
    )
  }
}
